import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IndicadorService } from './indicador.service';
import { NgxPaginationModule } from 'ngx-pagination';
import { PipesModule } from '../comum/filtros/pipes/pipes.module';
import { ComumModule } from '../comum/comum.module';
import { PontoFisicoService } from '../ponto-fisico/ponto-fisico.service';
import { ProcessoService } from '../processo/processo.service';
import { routing } from '../rotas';
import { RotinaService } from '../rotina/rotina.service';
import { SetorService } from '../setor/setor.service';
import { CadastroIndicadorComponent } from './cadastro-indicador/cadastro-indicador.component';
import { ListarIndicadoresComponent } from './listar-indicadores/listar-indicadores.component';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LoadingModule, ANIMATION_TYPES } from 'ngx-loading';
import { MultiSelectModule, ConfirmDialogModule, ConfirmationService, DropdownModule } from 'primeng/primeng';
import { CookieService } from 'angular2-cookie/services/cookies.service';

@NgModule({
  imports: [
    CommonModule,
    NgxPaginationModule,
    NgbModule,
    PipesModule,
    ComumModule,
    routing,
    FormsModule,
    LoadingModule.forRoot({
      animationType: ANIMATION_TYPES.circle
    }),
    MultiSelectModule,
    ConfirmDialogModule,
    DropdownModule
  ],
  declarations: [CadastroIndicadorComponent, ListarIndicadoresComponent],
  exports: [CadastroIndicadorComponent, ListarIndicadoresComponent],
  providers: [IndicadorService, PontoFisicoService, SetorService, ProcessoService, RotinaService, ConfirmationService, CookieService]
})
export class IndicadorModule { }



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/indicador/indicador.module.ts